/*
 * Copyright (c) 2010, 2023 BSI Business Systems Integration AG
 *
 * This program and the accompanying materials are made
 * available under the terms of the Eclipse Public License 2.0
 * which is available at https://www.eclipse.org/legal/epl-2.0/
 *
 * SPDX-License-Identifier: EPL-2.0
 */
import {Alignment, Status} from '../index';

export interface CellModel<TValue = any> {
  cssClass?: string;
  editable?: boolean;
  errorStatus?: Status;
  horizontalAlignment?: Alignment;
  htmlEnabled?: boolean;
  iconId?: string;
  mandatory?: boolean;
  text?: string;
  flowsLeft?: boolean;
  empty?: boolean;
  value?: TValue;
  tooltipText?: string;
  foregroundColor?: string;
  backgroundColor?: string;
  font?: string;
  sortCode?: number;
}
